<template>
  <div>
    <el-dialog title="成员管理" :visible.sync="show" :width="groupUserDialog.width" :before-close="handleClose">
      <div v-if="roleData && roleData.actions.addGroupUser === 1" style="padding:0 5px">
        <span>分组名称：{{ groupTitle }}</span>
        <div style="margin:15px 0">添加成员:</div>
        <div>
          <span style="width: 50px;"> 小程序id：</span>
          <el-input placeholder="请输入小程序ID" v-model="groupUserDialog.wechatToken" style="width: 300px;">
          </el-input>
        </div>
        <div style="margin-top:20px">
          <span style="width: 50px;"> 选择权限：</span>
          <el-select v-model="groupUserDialog.rolePickerValue" placeholder="请选择">
            <el-option v-for="item in groupUserDialog.roleProfile" :key="item.id" :label="item.title" :value="item.id">
              <span style="float: left">{{ item.title }}</span>
            </el-option>
          </el-select>
        </div>
        <div style="margin-top:20px">
          <el-button style="width:100px" type="success" plain @click="saveAddGroupUser">添加</el-button>
        </div>
      </div>
      <div style="padding:10px">
        <div>成员列表：</div>
        <el-table :data="groupUsers" style="width: 100%">
          <el-table-column prop="nickName" label="昵称" width="80">
          </el-table-column>
          <el-table-column prop="title" label="权限" width="80">
          </el-table-column>
          <el-table-column prop="wechatToken" label="小程序id">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-dropdown size="small" @command="editGroupUser" split-button type="primary">
                修改权限
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :disabled="scope.row.roleId === item.id ? true : false" :command="{roleId: item.id, user: scope.row}" v-for="item in groupUserDialog.roleProfile" :key="item.id">{{item.title}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button v-if="roleData && roleData.actions.removeGroupUser === 1" style="margin-left:5px;" size="mini" type="danger" @click="removeGroupUser(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    groupTitle: {
      type: String,
      default: null,
    },
    roleId: {
      type: Number,
      default: null,
    },
    groupId: {
      type: Number,
      default: null,
    },

  },
  data() {
    return {
      groupUserDialog: {
        width: '660px',
        wechatToken: '',
        rolePicker: null,
        rolePickerValue: null,
      },
      groupUsers: [],
      show: true,
      roleProfile: [],
      roleData: null,
    }
  },
  watch: {
    'groupId': {
      handler(val) {
      }
    }
  },
  methods: {
    getGroupUsers() {
      let json = {
        "cmd": "groupUsers",
        "groupId": this.groupId
      }
      this.ws.send(json);
    },
    handleClose() {
      this.show = false
      this.$emit('handleClose', false);
    },
    saveAddGroupUser() {
      // console.log(this.groupUserDialog);
      const wechatToken = this.groupUserDialog.wechatToken
      const roleId = this.groupUserDialog.rolePickerValue
      if (wechatToken == "" || roleId == "") {
        this.common.cToast(this, '请填写小程序id或选择权限')
        return
      }
      let json = {
        "cmd": "addGroupUser",
        "groupId": this.groupId,
        "wechatToken": wechatToken,
        "roleId": roleId
      }
      this.ws.send(json);
    },
    //修改权限
    editGroupUser(data) {
      // console.log(5551, data);
      const wechatToken = data.user.wechatToken

      let json = {
        "cmd": "editGroupUser",
        "groupId": this.groupId,
        "wechatToken": wechatToken,
        "roleId": data.roleId
      }
      this.ws.send(json);
    },
    removeGroupUser(row) {
      this.$confirm('确认删除[' + row.nickName
        + ']用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let json = {
          "cmd": "removeGroupUser",
          "groupId": this.groupId,
          "wechatToken": row.wechatToken
        }
        this.ws.send(json);

      }).catch(() => {

      });
    }

  },
  created() {
    this.ws.addCallback("groupUsersAck", (res) => {
      if (res) {
        let users = res.users
        let roleProfile = this.$store.getters['groupsStore/getRoleProfile']
        this.roleData = roleProfile.find(r => r.id === parseInt(this.roleId))
        console.log(555, this.roleData, roleProfile, this.roleId);


        this.groupUserDialog.roleProfile = roleProfile
        users.forEach(user => {
          const matchedRole = roleProfile.find(r => r.id === user.roleId)
          if (matchedRole) {
            user.title = matchedRole.title
          }
        });
        this.groupUsers = users;

      }
    })
    this.ws.addCallback("addGroupUserAck", (res) => {
      if (res.error == 0) {
        this.getGroupUsers()

        this.common.cResultOk(this);
      } else {
        let errorMsg = this.common.checkGroupErrorDesc(res.error);
        this.common.cResultNo(this, errorMsg);
      }
    })
    this.ws.addCallback("editGroupUserAck", (res) => {
      if (res.error == 0) {
        this.getGroupUsers()
        this.common.cResultOk(this);
      } else {
        let errorMsg = this.common.checkGroupErrorDesc(res.error);
        this.common.cResultNo(this, errorMsg);
      }
    })
    this.ws.addCallback("removeGroupUserAck", (res) => {
      if (res.error == 0) {
        this.getGroupUsers()
        this.common.cResultOk(this);
      } else {
        let errorMsg = this.common.checkGroupErrorDesc(res.error);
        this.common.cResultNo(this, errorMsg);
      }
    })
  },
  mounted() {
    this.getGroupUsers();

  },
}
</script>

<style>
</style>